import React from "react";
import { Icon } from "./Icon";

/**
 * A toggle, not a button (REG-A): a <button> with `aria-pressed` when it has an
 * `onClick` (a span otherwise), 44px
 * tall on phones (`.fx-chip`), and "selected" shown as a tint plus a border —
 * never solid gold, which is reserved for the one primary on the screen.
 */
export function Chip({ icon, selected = false, onRemove, children, style = {}, ...rest }) {
  const [hover, setHover] = React.useState(false);
  // Only a chip that does something is a button; a label inside a <Link> (the
  // sources row) stays a span, or the page would nest a button in an anchor.
  const El = rest.onClick ? "button" : "span";
  return (
    <El
      type={El === "button" ? "button" : undefined}
      className="fx-chip"
      aria-pressed={El === "button" ? selected : undefined}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "inline-flex", alignItems: "center", gap: "var(--space-2)",
        // PORT NOTE (DY1.4): a chip is content the model chose, not copy we
        // wrote — a long ES category or a suggestion phrased as a sentence
        // must wrap inside the row rather than widen it past the page padding.
        maxWidth: "100%", overflowWrap: "anywhere",
        borderRadius: "var(--radius-pill)", padding: "6px 14px",
        fontFamily: "var(--font-body)", fontSize: "var(--text-sm)",
        background: selected ? "var(--hive-a20)" : hover ? "var(--linen)" : "var(--surface-raised)",
        border: `1px solid ${selected || hover ? "var(--hive)" : "var(--border-default)"}`,
        color: "var(--text-body)", cursor: "pointer", textAlign: "left",
        transition: "background-color var(--duration-base) var(--ease-out), border-color var(--duration-base) var(--ease-out)",
        ...style,
      }}
      {...rest}
    >
      {icon && <Icon name={icon} size={14} style={{ color: "var(--text-accent)" }} />}
      {children}
      {onRemove && (
        <Icon name="x" size={13} style={{ color: "var(--text-muted)" }}
          onClick={(e) => { e.stopPropagation(); onRemove(); }} />
      )}
    </El>
  );
}
